export const getCustomerName = (tableNumber: string) => {
    const name = tableNumber.split("-").slice(1, -1).join("-");
    if (!name || name.toUpperCase() === "MEANDU") return null;
    return `${name.slice(0, -1)} ${name.slice(-1)}`;
};
